import { render, staticRenderFns } from "./DetailConfigDatasetGroupChoose.vue?vue&type=template&id=d685a71c"
import script from "./DetailConfigDatasetGroupChoose.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetGroupChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports